import DgSidebarMenu from "./SidebarMenu";

DgSidebarMenu.install = Vue => {
  Vue.component(DgSidebarMenu.name, DgSidebarMenu);
};

export default DgSidebarMenu;
